(function () {
  const form = document.getElementById('ContactForm');
  if (!form) return;

  const body = form.querySelector('#ContactForm-body');
  const counter = form.querySelector('[data-contact-form-count]');

  if (body && counter) {
    const updateCount = () => {
      counter.textContent = body.value.length;
    };
    body.addEventListener('input', updateCount);
    updateCount();
  }

  const type = form.querySelector('#ContactForm-type');

  // Some browsers silently restore a select's last-used value when this page
  // is revisited (e.g. after the redirect below), overriding whatever the
  // customer actually picks. Force it back to the placeholder on every load.
  if (type) {
    type.value = '';
  }

  const email = form.querySelector('#ContactForm-email');
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const VALIDATORS = {
    type: () => (type && type.value !== '' ? '' : 'Please select a topic.'),
    email: () => {
      if (!email || email.value.trim() === '') return 'Please enter your email.';
      if (!EMAIL_PATTERN.test(email.value.trim())) return 'Please enter a valid email address.';
      return '';
    },
    body: () => (body && body.value.trim() !== '' ? '' : 'Please enter a message.'),
  };

  const setFieldError = (field, message) => {
    const errorEl = form.querySelector(`[data-error-for="${field}"]`);
    const inputEl = field === 'type' ? type : field === 'email' ? email : body;
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = !message;
    }
    if (inputEl) {
      if (message) {
        inputEl.setAttribute('aria-invalid', 'true');
      } else {
        inputEl.removeAttribute('aria-invalid');
      }
    }
  };

  const validateField = (field) => {
    const message = VALIDATORS[field]();
    setFieldError(field, message);
    return message === '';
  };

  Object.keys(VALIDATORS).forEach((field) => {
    const inputEl = field === 'type' ? type : field === 'email' ? email : body;
    if (inputEl) {
      inputEl.addEventListener('blur', () => validateField(field));
    }
  });

  form.addEventListener('submit', (event) => {
    const results = Object.keys(VALIDATORS).map((field) => validateField(field));
    if (results.includes(false)) {
      event.preventDefault();
      const firstInvalid = form.querySelector('[aria-invalid="true"]');
      if (firstInvalid) firstInvalid.focus();
    }
  });

  // The form's `return_to` field sends Shopify back here with ?contact_success=1
  // on a successful submission (see contact-form.liquid). Shopify's `return_to`
  // redirect is a real GET, so this is a plain page load — no risk of a refresh
  // replaying the original POST — but it also means `form.posted_successfully?`
  // isn't set on this render, so we key off the query param instead.
  const params = new URLSearchParams(window.location.search);

  if (params.get('contact_success') === '1' && !form.querySelector('.contact-form__message--success')) {
    params.delete('contact_success');
    const cleanSearch = params.toString();
    const cleanUrl = window.location.pathname + (cleanSearch ? `?${cleanSearch}` : '') + window.location.hash;
    window.history.replaceState({}, '', cleanUrl);

    const message = document.createElement('p');
    message.className = 'contact-form__message contact-form__message--success';
    message.setAttribute('tabindex', '-1');
    message.textContent = 'Thanks for reaching out! We’ll get back to you soon.';
    form.appendChild(message);
    message.focus();
  }
})();
